module.exports = __webpack_public_path__ + "img/chicago-manual.1236c030.jpg";